import React, { useEffect, useState } from "react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";
import { Coins } from "lucide-react";

export default function Criptovalute() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Criptovalute", "Cryptocurrencies", "Kryptowährungen"), L("Le reti e criptovalute supportate da Recovers Crypto.", "The networks and cryptocurrencies supported by Recovers Crypto.", "Die von Recovers Crypto unterstützten Netzwerke und Kryptowährungen."));
  const [cryptos, setCryptos] = useState([]);
  useEffect(() => { api.get("/content/cryptocurrencies").then(({ data }) => setCryptos(data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHero eyebrow={L("Criptovalute", "Cryptocurrencies", "Kryptowährungen")} title={L("Reti e valute", "Networks and currencies", "Netzwerke und Währungen")}
        subtitle={L("Analizziamo casi relativi alle principali reti e criptovalute. La fattibilità dipende dal tipo di wallet.", "We analyze cases involving the main networks and cryptocurrencies. Feasibility depends on the wallet type.", "Wir analysieren Fälle rund um die wichtigsten Netzwerke und Kryptowährungen. Die Machbarkeit hängt vom Wallet-Typ ab.")} />
      <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {cryptos.map((c) => (
            <div key={c.id} className="rounded-xl border border-white/10 bg-navy-paper p-6 flex items-center gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-gold/10 text-gold border border-gold/20"><Coins className="h-5 w-5" /></span>
              <div><div className="font-heading text-white font-medium">{c.symbol}</div><div className="text-xs text-slate-500">{c.name}</div></div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
